import { Injectable } from '@angular/core';

import { TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { selectTrackingDetails } from '../../../quick-bet/quick-bet.selectors';

export enum PlaceButtonTracking {
    NotApplicable = 'not applicable',
    Betting = 'betting',
    Betslip = 'Betslip',
    Click = 'click',
    QuickBet = 'QuickBet',
    EditMyBet = 'Edit My Bet',
    PlaceBet = 'Place bet',
    PlaceFreeBet = 'Place free bet',
    AcceptChanges = 'Accept changes',
    AcceptAndPlace = 'Accept&place bet',
    AcceptAndPlaceFreeBet = 'Accept&place freebet',
    LoginToBet = 'Login to bet',
    MakeDeposit = 'Make a deposit',
    MinimumStake = 'minimum stake',
    Deposit = 'Deposit',
    DepositAndPlace = 'Deposit&place bet',
    Confirm = 'Confirm',
    SaveChanges = 'Save changes',
    UpdateStake = 'Update Stake',
    UpdateStakes = 'Update Stakes',
    BetPlacement = 'Bet Placement',
    CtaClick = 'CTA - Click',
}

@Injectable()
export class PlaceButtonTrackingService {
    constructor(private trackingService: TrackingService) {}

    track(actionName: string, buttonLocation: string): void {
        this.trackingService.track(trackingConstants.EVENT_CLICKS, {
            ...this.getBaseTrackData(),
            [trackingConstants.COMPONENT_LABEL_EVENT]: actionName,
            [trackingConstants.COMPONENT_POSITION_EVENT]: buttonLocation,
        });
    }

    trackQuickBetPlaceBet(actionName: string, buttonLocation: string, details: ReturnType<typeof selectTrackingDetails>): void {
        this.trackingService.track(trackingConstants.EVENT_CLICKS, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: PlaceButtonTracking.BetPlacement,
            [trackingConstants.COMPONENT_ACTION_EVENT]: PlaceButtonTracking.CtaClick,
            [trackingConstants.COMPONENT_URL_CLICKED]: PlaceButtonTracking.NotApplicable,
            [trackingConstants.COMPONENT_LABEL_EVENT]: actionName,
            [trackingConstants.COMPONENT_POSITION_EVENT]: buttonLocation,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: details.pickCount,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: details.mode,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: PlaceButtonTracking.PlaceBet,
        });
    }

    private getBaseTrackData(): TrackData {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: PlaceButtonTracking.BetPlacement,
            [trackingConstants.COMPONENT_ACTION_EVENT]: PlaceButtonTracking.CtaClick,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: PlaceButtonTracking.NotApplicable,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: PlaceButtonTracking.NotApplicable,
            [trackingConstants.COMPONENT_URL_CLICKED]: PlaceButtonTracking.NotApplicable,
        };
    }

    updateStakeTrackData(locationEvent: string, eventDetails: string): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: PlaceButtonTracking.Betting,
            [trackingConstants.COMPONENT_LABEL_EVENT]: PlaceButtonTracking.MinimumStake,
            [trackingConstants.COMPONENT_ACTION_EVENT]: PlaceButtonTracking.Click,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: locationEvent,
            [trackingConstants.COMPONENT_POSITION_EVENT]: locationEvent,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: eventDetails,
            [trackingConstants.COMPONENT_URL_CLICKED]: PlaceButtonTracking.NotApplicable,
            [trackingConstants.EVENT_NAME]: PlaceButtonTracking.Betting,
        });
    }
}
